<template>
	<inertia-head title="Stock Alert Content" />
	<div class="bg-primary">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">Stock Alert Content</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						Manage user's Stock Alert Content
					</h2>
				</div>
			</div>
		</div>
	</div>
	<div class="content">
		
		<div class="text-end mb-4">
			<button @click="viewStockAlertContentModal(0,'add')" class="btn btn-alt-primary">
				<i class="fa fa-plus me-1"></i>
				Add Stock Alert
			</button>
		</div>
		<div class="block">
			<div class="block-content block-content-full">
				<div class="table-responsive">
					<table class="table table-borderless table-striped table-vcenter">
						<thead>
							<tr>
								<th>Stock Alert</th>
								<th>Status</th>
								<th>Date Appear</th>
								<th>Last Update</th>
								<th class="text-end">:::::</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(stock, index) in stockAlerts.data" :key="index">
								<td>{{ stock.desc_short }}</td>
								<td>
									<span class="badge" :class="{'bg-success':stock.status==1,'bg-danger':stock.status==0}">{{ stock.status_format }}</span>
								</td>
								<td>{{ stock.display_date_format }}</td>
								<td>{{ stock.last_update_format }}</td>
								<td class="text-end">
									<button @click="viewStockAlertContentModal(index,'update')" class="btn btn-sm btn-alt-info me-1"><i class="fa fa-pencil-alt"></i></button>
									<button @click="confirmDelete(index)" class="btn btn-sm btn-alt-danger"><i class="fa fa-times" data-toggle="modal" data-backdrop="static" data-target="#DeleteDialog"></i></button>
								</td>
							</tr>
							<tr v-if="stockAlerts.data.length <= 0" >
								<td colspan="5" class="text-center"><p class="mb-0 fw-semibold text-danger">NO STOCK ALERT FOUND</p></td>
							</tr>
						</tbody>
					</table>
				</div>
				<pagination :collections="stockAlerts" />
			</div>
		</div>


		<modal ref="deleteModal">
			<template #title>DELETE CONFIRMATION</template>
			<template #body>
				<div class="text-center">
                    <p class="h6">
                        Are you sure, you want to delete this Email Swipe?
                    </p>
                </div>
			</template>
			<template #footer>
				<button type="button" @click="deleteStockAlert()" class="btn btn-alt-primary btn-sm"><i class="fa fa-check-circle"></i> YES</button>
                <button @click="deleteModal.toggleModal" type="button" id="btnDeleteClose" class="btn btn-alt-danger btn-sm"><i class="fa fa-times-circle"></i> NO</button>
			</template>
		</modal>

		
		<add-update-stock-alert-modal
		ref="addUpdateStockAlertModal"
		></add-update-stock-alert-modal>

	</div>
</template>

<script>
import { onMounted, ref, watch, reactive  } from 'vue'
import AuthLayout from '../../../Layouts/AuthLayout'
import AddUpdateStockAlertModal from '../../../Components/Admin/SiteManagement/AddUpdateStockAlertModal'
import { createToaster } from '@meforma/vue-toaster';
import { Inertia } from '@inertiajs/inertia'

export default {
	layout: AuthLayout,
	props:{
		stockAlerts : Object,
		api_response : Object
	},
	components:{AddUpdateStockAlertModal},
	setup(props) {
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
				pageContainer.classList.remove('sidebar-o-xs')
		})

		const toast = createToaster();

		const cur_index = ref(null);

		const action 				= ref('add');

		const deleteModal 				= ref(null);
		const addUpdateStockAlertModal 	= ref(null);

		const selectedStockAlertContent = reactive({});

		const confirmDelete = (_index)=>{
			cur_index.value = _index;
			deleteModal.value.toggleModal();
		}

		const viewStockAlertContentModal = (_index,_action)=>{
			
			action.value = _action;
			
			if(_action=='update')
			{
				selectedStockAlertContent.id 				= props.stockAlerts.data[_index].id;
				selectedStockAlertContent.description 		= props.stockAlerts.data[_index].description;
				selectedStockAlertContent.tags 				= props.stockAlerts.data[_index].tags;
				selectedStockAlertContent.tags_arr 			= props.stockAlerts.data[_index].tags_arr;
				selectedStockAlertContent.display_date 		= props.stockAlerts.data[_index].display_date;
				selectedStockAlertContent.status 			= props.stockAlerts.data[_index].status;
			}

			addUpdateStockAlertModal.value.setStockAlertContent(_action,selectedStockAlertContent);

			addUpdateStockAlertModal.value.toggleModal();

		}

		const deleteStockAlert = () => {
			action.value = "delete";
			var id = props.stockAlerts.data[cur_index.value].id;

			Inertia.delete('stock-alert/'+id, {
				preserveState: true,
				preserveScroll: true,
				only:['stockAlerts,api_response'],
				onSuccess: () => {
					deleteModal.value.toggleModal();
				},
			})
		}


		watch(()=>props.api_response, (value) => {
			
			if(value!=null)
			{
				var action_msg = action.value=='add' ? 'added' : (action.value=='delete' ? 'deleted' : 'updated');

				if(value.result=="success")
				{
					toast.show("Successfully "+action_msg, { type: value.result});
				}else
				{
					toast.show("Failed to "+action_msg, { type: "error"});
				}
			}
		})

		return{
			cur_index,
			action,
			selectedStockAlertContent,
			confirmDelete,
			deleteStockAlert,
			deleteModal,
			addUpdateStockAlertModal,
			viewStockAlertContentModal,
		}
	},
}
</script>
